import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarTelefonesPorContaService(IDConta: number) {
    return Service(
        Axios.get<any>(
            `/home/contatelefone/listartelefonesconta?IDConta=${IDConta}`
        )
    );
}
